
import React, { createContext, useState, useContext, useEffect, useMemo } from "react";

import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { Header } from "./header/Header";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { ScrollTop } from "./extras/ScrollTop";
import { StickyToolbar } from "./extras/StickyToolbar";
import { SubMenus } from "../../../app/models/security.model";
import { any } from "prop-types";


type UserContextType = {
  context: any | null,
  setContext: React.Dispatch<React.SetStateAction<any | null>>
}

const iUserContextState = {
 context: null,
 setContext: () => {}
}

export const UserContext = createContext<UserContextType>(iUserContextState)

//export const TitleContext = React.createContext<string | null>(null);
export function Layout({ children }: { children: any }) {
  
  const uiService = useHtmlClassService();
  const [refreshQuickCartable, setRefreshQuickCartable] = useState<boolean>();
  const [context, setContext] = useState<any | null>(null);

  
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  useEffect(() => {
    if (refreshQuickCartable != undefined && refreshQuickCartable == true) {
      setRefreshQuickCartable(undefined);
    }
  }, [refreshQuickCartable]);


  return layoutProps.selfLayout !== "blank" ? (
    <>

      <UserContext.Provider value={{context, setContext}}>
        {/*begin::Main*/}

        <HeaderMobile />
        <div className="d-flex flex-column flex-root">
          {/*begin::Page*/}
          <div className="d-flex flex-row flex-column-fluid page">
            {layoutProps.asideDisplay && (
              <Aside setRefreshQuickCartable={setRefreshQuickCartable} />
            )}
            {/*begin::Wrapper*/}
            <div
              className="d-flex flex-column flex-row-fluid wrapper"
              id="kt_wrapper"
            >
              <Header refreshQuickCartable={refreshQuickCartable} />
              {/*begin::Content*/}
              <div
                id="kt_content"
                className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
              >
                {layoutProps.subheaderDisplay && <SubHeader />}
                {/*begin::Entry*/}
                {!layoutProps.contentExtended && (
                  <div className="d-flex flex-column-fluid">
                    {/*begin::Container*/}
                    <div className={layoutProps.contentContainerClasses}>
                      {children}
                    </div>
                    {/*end::Container*/}
                  </div>
                )}

                {layoutProps.contentExtended && { children }}
                {/*end::Entry*/}
              </div>
              {/*end::Content*/}
              {/* <Footer/> */}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/* <StickyToolbar /> */}
          {/*end::Page*/}
        </div>
        {/* <QuickUser/> */}
        {/* <QuickPanel/> */}
        <ScrollTop />
        {/*end::Main*/}
        <LayoutInit />
      </UserContext.Provider>
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
